<template>
  <div v-if="index === selectedTab">
    <slot />
  </div>
</template>

<script setup>
import { inject, ref, onMounted } from 'vue';

const props = defineProps({
  title: String
});

const registerTab = inject('registerTab');
const selectedTab = inject('selectedTab');
const index = ref(null);

onMounted(() => {
  index.value = registerTab({ title: props.title });
});
</script>
